import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { loadingStart, loadingSuccess, loadingFailure } from "./loading";
import { updateGame } from "./ggame";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const authResetSlice = createSlice({
  name: "resetauth",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

// Actions
export const {     } =
  authResetSlice.actions;

export const ResetSlice = (data) => async (dispatch) => {
  try {
    dispatch(loadingStart());
    const response = await axios.post(`/private/user/resetpass`, data);
    if (response.status === 200) {
      const game = response.data.game;
      if (game) {
        dispatch(updateGame(game));
      }
      toast.success("Your password successfully Reset!");
      dispatch(loadingSuccess("Created successfully!"));
    } else if (response.status === 202) {
      toast.success("Your password change Request in progress!");
      dispatch(loadingSuccess("Created successfully!"));
    }
  } catch (err) {
    // Handle errors
    toast.error(err?.response?.data?.message || err.message || "Login failed!");
    dispatch(loadingFailure("here is curernt error"));
  }
};

export default authResetSlice.reducer;
